import { defineComponent as _defineComponent } from 'vue';
import { useGetUserQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'ActionMenu',
  props: {
    selected: null
  },
  setup: function setup(__props) {
    var _useGetUserQuery = useGetUserQuery(),
      result = _useGetUserQuery.result;
    var user = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getUser;
    });
    return {
      __sfc: true,
      result: result,
      user: user
    };
  }
});